/**
 * Copyright (c) [2026] SUSE Linux
 *
 * This software may be modified and distributed under the terms
 * of the MIT license.  See the LICENSE.txt file for details.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Toast from './Toast';

const POSITION_STYLES = {
  'top-left': 'top-4 left-4 items-start',
  'top-center': 'top-4 left-1/2 transform -translate-x-1/2 items-center',
  'top-right': 'top-4 left-1/2 transform -translate-x-1/2 items-center',
  'bottom-left': 'bottom-4 left-4 items-start',
  'bottom-center': 'bottom-4 left-1/2 transform -translate-x-1/2 items-center',
  'bottom-right': 'bottom-4 right-4 items-end',
};

function ToastContainer({ toasts, onClose, position = 'top-center', maxToasts = 5 }) {
  const positionStyle = POSITION_STYLES[position] || POSITION_STYLES['top-center'];
  
  return (
    <div
      className={`fixed z-50 flex flex-col ${positionStyle} pointer-events-none`}
      style={{ maxWidth: 'calc(100% - 2rem)' }}
    >
      {toasts.slice(0, maxToasts).map((toast) => (
        <div key={toast.id} className="pointer-events-auto">
          <Toast
            id={toast.id}
            type={toast.type}
            message={toast.message}
            duration={toast.duration}
            onClose={onClose}
            showClose={toast.showClose}
          />
        </div>
      ))}
    </div>
  );
}

ToastContainer.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
      message: PropTypes.string.isRequired,
      duration: PropTypes.number,
      showClose: PropTypes.bool,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  position: PropTypes.oneOf([
    'top-left',
    'top-center',
    'top-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
  ]),
  maxToasts: PropTypes.number,
};

export default ToastContainer;